import React from 'react'
import { WemoloTypography } from '../../../components/Wemolo'
import styles from './LiveViewError.module.css'

interface LiveViewErrorProps {
    message?: string | React.ReactNode
}

export const LiveViewError: React.FC<LiveViewErrorProps> = ({ message }) => {
    if (!message) return null

    return (
        <div className={styles.root}>
            <WemoloTypography variant="body-medium" tag="p" className={styles.message}>
                {message}
            </WemoloTypography>
        </div>
    )
}
